export default __webpack_public_path__ + "static/media/DSC_0517.0444ca54.jpg";